import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS, SUMMARY_ROUTES } from 'cpool-constants';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { schemaLeadSummaryList } from '~/features/leadList/schemas/leadSummaryList.schema';
import type { LeadListFilter } from '~/features/leadList/schemas/route.schema';
import { schemaUnionLeadListSearch } from '~/features/leadList/schemas/route.schema';
import { LEAD_LIST_ACTION_FILTER } from '~/features/leadList/utils/actionFilters/leadListActionFilter';
import { buildLoanRequestGetSummarySearchParams } from '~/features/leadList/utils/buildLoanRequestGetSummarySearchParams';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const loanRequestSummaryQueryOptions = (filter: LeadListFilter) =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getSummary,
        schema: schemaLeadSummaryList,
        searchParams: buildLoanRequestGetSummarySearchParams({
            filter,
            permissionsActionFilter: LEAD_LIST_ACTION_FILTER,
            route: SUMMARY_ROUTES.BUCKET_LEADS,
        }),
    });

export const Route = createFileRoute(SUMMARY_ROUTES.BUCKET_LEADS)({
    beforeLoad: ({ location }) => {
        authoriseUser(Object.values(ROLES), location);
        const content = 'ROUTE_TITLE.BUCKET_LEADS';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    // eslint-disable-next-line sort/object-properties
    loaderDeps: ({ search }) => search,
    loader: async ({ context, deps: filter }) =>
        context.queryClient.ensureQueryData(loanRequestSummaryQueryOptions(filter)),
    validateSearch: schemaUnionLeadListSearch,
});
